import React from 'react'
import { Switch, Route, RouteComponentProps } from 'react-router'

import { EditContainer } from './Edit'
import { INSTALLATIONS_URL, installationsEdit, INSTALLATIONS_CREATE_URL } from '../../../constants/urls/frontend'
import { CreateContainer } from './Create'
import { DisplayContainer } from './Display/DisplayContainer'

const InstallationsPage: React.FC<RouteComponentProps> = (): JSX.Element => {
  return (
    <Switch>
      <Route path={installationsEdit()} component={EditContainer} />
      <Route path={INSTALLATIONS_CREATE_URL} component={CreateContainer} />
      <Route path={INSTALLATIONS_URL} component={DisplayContainer} />
    </Switch>
  )
}

export {
  InstallationsPage
}
